import React from 'react';
import { Facebook, Twitter, Linkedin, Youtube, Instagram, Globe } from 'lucide-react';
import CiscoLogo from './CiscoLogo';
import { footerColumns } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#f4f7fb] text-[#23282e]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14">
        <div className="flex items-center justify-between mb-10">
          <CiscoLogo className="h-10" color="#0d274d" />
          <div className="flex items-center gap-3">
            {[Facebook, Twitter, Linkedin, Youtube, Instagram].map((Icon, i) => (
              <a key={i} href="#" className="p-2 rounded-full border border-gray-300 hover:border-[#00bceb] hover:text-[#00bceb] transition-colors" aria-label="Social">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-semibold text-[#0d274d] mb-4">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="text-sm text-gray-700 hover:text-[#00bceb] hover:underline">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-gray-600">
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <a href="#" className="hover:text-[#00bceb]">Contacts</a>
            <a href="#" className="hover:text-[#00bceb]">Feedback</a>
            <a href="#" className="hover:text-[#00bceb]">Help</a>
            <a href="#" className="hover:text-[#00bceb]">Site Map</a>
            <a href="#" className="hover:text-[#00bceb]">Terms &amp; Conditions</a>
            <a href="#" className="hover:text-[#00bceb]">Privacy Statement</a>
            <a href="#" className="hover:text-[#00bceb]">Cookie Policy</a>
            <a href="#" className="hover:text-[#00bceb]">Trademarks</a>
          </div>
          <div className="flex items-center gap-3">
            <Globe className="w-3.5 h-3.5" />
            <span>India / English</span>
            <span className="text-gray-400">|</span>
            <span>&copy; {new Date().getFullYear()} Cisco Systems, Inc.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
